module.exports = __webpack_public_path__ + "static/img/zwf.0f941c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/zwf.jpg
// module id = 5fH9
// module chunks = 0